import type { LocaleOfStoreType } from "@beautypie/core";
import { useAppContext } from "hooks";

export const useLocale = (): LocaleOfStoreType => {
  const context = useAppContext();
  return context.locale;
};
